// HomePageContent.jsx
import React from 'react';
import HeroSection from './HeroSection';
import InterfaceSection from './InterfaceSection';
import CTASection from './CTASection';
import ScrollReveal from './ScrollReveal';

const actions = [
  { label: "Créer mon compte gratuit", to: "https://maclectic.com/register", primary: true, target: "_self" },
  { label: "En savoir plus", to: "/about", primary: false }
];

const HomePageContent = ({ variant = 'desktop' }) => (
  <div className={`landing-page landing-page--${variant}`}>
    <HeroSection />
    <InterfaceSection variant={variant} />
    <ScrollReveal>
      <CTASection
        title="Prêt à reprendre le contrôle ?"
        subtitle="Maclectic vous aide à transformer vos habitudes en progression mesurable."
        actions={actions}
        variant="default"
      />
    </ScrollReveal>
  </div>
);

export default HomePageContent;
